import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kinderbetreuung',
  templateUrl: './kinderbetreuung.component.html',
  styleUrls: ['./../app.component.css']
})
export class KinderbetreuungComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
